import i18n from '@/locale/index';
let colors =['#779FFA','#FFB101','#07C18A'];
export let Config ={
        barOptions:{
            tooltip: {
            trigger: 'axis',
            // axisPointer: {
            //     type: 'cross',
            //     crossStyle: {
            //         color: '#999'
            //     }
            // }
        },
        color:colors,
        legend: {
            top:'3%',
            right:'0%',
            data: [i18n.t('components.dataBar.295794-0'), i18n.t('components.dataBar.295794-1'), i18n.t('components.dataBar.295794-2')]
        },
        grid: {
            bottom:'10%',
            right: '6%',
            left:'7%',
        },
        // dataZoom: [{
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0],
        //     left: '9%',
        //     bottom: -5,
        //     start: 10,
        //     end: 90 //初始化滚动条
        // }],
        xAxis: [
            {   
                type: 'category',
                data: [],
                axisPointer: {
                    type: 'shadow'
                },
                axisLabel:{
                    interval:0,
                    rotate:"0",
                    textStyle:{
                        color:'#333'
                    }
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: i18n.t('components.dataBar.295794-3'),
                min: 0,
                // // max: 250,
                interval: 100,
                splitLine:{
            　　　　show:false
            　　},
                axisLine:{
                    lineStyle:{
                        color:'#666'
                    }
                }
                // axisLabel: {
                //     formatter: '{value} ml'
                // }
            },
            {
                type: 'value',
                name: i18n.t('components.dataBar.295794-4'),
                min: 0,
                interval: 100,
                splitLine:{
            　　　　show:false
            　　},
                axisLine:{
                    lineStyle:{
                        color:'#666'
                    }
                }
                // axisLabel: {
                //     formatter: '{value} °C'
                // }
            }
        ],
        series: [
            {
                name: i18n.t('components.dataBar.295794-5'),
                type: 'bar',
                barWidth:'60%',
                data: [],
            },
            {
                name: i18n.t('components.dataBar.295794-1'),
                type: 'line',
                symbol: 'circle', 
                yAxisIndex: 1,
                smooth:true,
                data: [],
            },
            {
                name: i18n.t('components.dataBar.295794-2'),
                type: 'line',
                symbol: 'circle', 
                yAxisIndex: 1,
                smooth:true,
                data: [],
            }
        ]
    },
}; 
export function showWork(obj={}) {//修改获奖作品效果
    Config.barOptions.xAxis[0].data = obj.subjectList;
    Config.barOptions.series[0].data=obj.resCount;
    Config.barOptions.series[1].data=obj.praiseCount;
    Config.barOptions.series[2].data=obj.collectCount;
}